module.exports = __webpack_public_path__ + "img/logo_01.5d668977.png";